export default {
	styleOverrides: {
		input: {
			'&:-webkit-autofill': {
				boxShadow: '0 0 0px 1000px #FFF inset', // @TODO: color from palette
			},
		},
	},
};
